<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{width: '650px'}" (onHide)="cancel()">
    <ng-template pTemplate="header">
        <div class="w-full text-center font-22 font-weight-600" translate>guarantee.restitution
        </div>
    </ng-template>

    <div>
        <form #form="ngForm" (ngSubmit)="onSave()">
            <div class="m-auto">
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0">Document Number<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <input type="text" name="documentNumber" class="form-control" maxlength="10" required
                                #documentNumber="ngModel" [(ngModel)]="guaranteeRestitution.documentNumber">
                        <small class="text-danger">
                            {{documentNumber.valid || !submittedForm ? '&nbsp;' : 'This field is required'}}
                        </small>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0"><span translate>guarantee.number</span><span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <input type="text" name="agreementNumber" class="form-control" readonly placeholder=""
                                    #agreementNumber="ngModel" [ngModel]="guaranteeRestitution.guaranteeAgreementNumber">
                        <br>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0">Date<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <p-calendar [(ngModel)]="guaranteeRestitution.date" class="w-full" [showIcon]="true"
                                    [showOnFocus]="false" placeholder="dd-mm-yyyy" dataType="string"
                                    dateFormat="dd-mm-yy" [style]="{'width':'100%'}"
                                    [inputStyle]="{'width':'100%'}" required
                                    name="date" #date="ngModel"
                                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange">
                        </p-calendar>
                        <small class="text-danger">
                            {{date.valid || !submittedForm ? '&nbsp;' : 'This field is required'}}
                        </small>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0">Amount<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <p-inputNumber name="amount"
                                    required
                                    [disabled]="true"
                                   [minFractionDigits]="2"
                                   [min]="0"
                                   placeholder="" #amount="ngModel" [ngModel]="guaranteeRestitution.amount">
                        </p-inputNumber>
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0">Purpose<span class="requireSym"></span>
                    </div>
                    <div class="col-7">
                        <input type="text" name="purpose" class="form-control" placeholder=""
                                #purpose="ngModel" [(ngModel)]="guaranteeRestitution.purpose" >
                    </div>
                </div>
                <div class="row h-68">
                    <div class="col-5 text-right font-14 pr-0">Branch<span class="requireSym">*</span>
                    </div>
                    <div class="col-7">
                        <p-dropdown [options]="branchCodeList" name="branch"
                                    placeholder="Select branch" optionLabel="name" optionValue="id"
                                    [(ngModel)]="guaranteeRestitution.branchId" #branch="ngModel"
                                    (onChange)="changeBranch($event.value)" class="w-full"
                                    [style]="{'width': '100%'}">
                        </p-dropdown>
                        <small class="text-danger">
                            {{branch.valid || !submittedForm ? '&nbsp;' : 'This field is required'}}
                        </small>
                    </div>
                </div>
            </div>
            
            <div class="form-input-row pt-20">
                <div class="d-flex justify-content-center">
                    <button pButton class="btn btn-primary mr-10 px-30 col-3" type="button" (click)="onSave()"
                        [disabled]="form.invalid" translate>buttons.save</button>
                    <button pButton class="btn btn-light ml-10 px-20 col-3" type="button" (click)="cancel()"
                        translate>buttons.cancel</button>
                </div>
            </div>
        </form>
    </div>
</p-dialog>
